<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Regulaminy</v-flex>

        <v-spacer></v-spacer>

        <v-flex>
          <v-text-field
            prepend-icon="mdi-magnify"
            name="search"
            label="Wyszukaj"
            color="white"
            clearable
            v-model="search"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="TERMS.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ REGULAMIN</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        editPerm="TERMS.UPDATE"
        deletePerm="TERMS.DELETE"
        :headers="table.headers"
        :items="list"
        :actions="true"
        :hideActions="false"
        :total-count="count"
        :search="search"
        @pagination="reloadList"
        @add="showAddModal"
        @edit="showEditModal"
        @delete="deleteTerms"
      ></material-table>

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy napewno chcesz usunąć regulamin?"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      ></material-dialog>
    </material-card>

    <modal
      :show="showModal"
      :id="idToEdit"
      :edit="!!idToEdit"
      @close="hideModal"
      @save="addTerms"
      @update="updateTerms"
    ></modal>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { ProfileType, ProfileTypeTranslation } from '@witkac/kartamiejska-shared';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Modal from './addTerms.modal';
import { listMixin } from '@/mixins/list';

// @vuese
// Wyświetlanie listy regulaminów
// @group Terms
export default {
  mixins: [
    listMixin('terms', {
      listError: 'Wystąpił błąd podczas pobierania listy regulaminów.',
      getError: 'Wystąpił błąd podczas pobierania danych regulaminu.',
      added: 'Dodano regulamin.',
      addError: 'Nie udało się dodać regulaminu.',
      updated: 'Zaktualizowano dane regulaminu.',
      updateError: 'Nie udało się zaktualizować danych regulaminu.',
      deleted: 'Usunięto regulamin.',
      deleteError: 'Nie udało się usunąć regulaminu.'
    })
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    MaterialTable,
    Modal
  },
  methods: {
    // @vuese
    // Dodaje regulamin
    addTerms(data) {
      this.add({ terms: { ...data } });
    },
    // @vuese
    // Aktualizuje regulamin
    updateTerms(data) {
      const id = data.id;
      data.id = undefined;
      this.update({ terms: { ...data }, id });
    },
    // @vuese
    // Sprawdza czy można usunąć regulamin
    deleteTerms(id) {
      this.list.find(terms => terms.id === id).consents.length > 0
        ? this.$store.dispatch('notifyError', { title: 'Nie można usunąć regulaminu, który posiada zgody' })
        : this.showDeleteDialog(id);
    }
  },
  computed: {
    ...mapState({
      list: state =>
        state.terms.list.map(terms => {
          terms.profileTypeTranslated = ProfileTypeTranslation[ProfileType[terms.profileType]];
          return terms;
        })
    })
  },
  data() {
    return {
      search: '',
      table: {
        headers: [
          { value: 'name', text: 'Nazwa regulaminu', sortable: true },
          { value: 'profileTypeTranslated', text: 'Typ profilu', sortable: true, paginationValue: 'profileType' }
        ]
      }
    };
  }
};
</script>
